// extracted by mini-css-extract-plugin
export default {"label":"Contact_label__yItNQ","options":"Contact_options__sRymU","form":"Contact_form__RZJDH","container":"Contact_container__1CyqF"};